import { BaseComponent } from 'components/BaseComponent';
import MainForm from 'components/Cart/MainForm';
import Price from 'components/Cart/Price';
import React from 'react';
import { cartService } from 'services/CartService';
import { History } from 'history';
import { Sidebar } from 'components/Cart/Sidebar';
import { ITemplateState, IPayProps } from 'components/Cart';
import { HistoryContext } from 'shared/HistoryContext';
import { Observable } from 'rxjs/Observable';
import { Switch, Route } from 'react-router-dom';
import { paymentService } from 'services/PaymentService';
import AskAddress from 'components/Cart/AskAddress';
import { ICartModel } from 'interfaces/ICartModel';
import { SvgIcon } from 'components/SvgIcon';
import { enProductType } from 'enums/enProductType';
import PriceQuantity from 'components/Cart/PriceQuantity';
import Footer from '../../../Footer/index';

const styles = require('./singleStep.css');

interface IState extends ITemplateState {
  payment: ICartModel;
}

export default class SingleStep extends BaseComponent<IState, IPayProps> {

  private history: History;

  constructor(props: any) {
    super(props);
  }

  public componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ payment: null }, paymentService.getCart());
  }

  public onPay = () => {

    if (paymentService.hasPaymentInProgress()) {
      return;
    }

    this.props
      .onPay()
      .switchMap(() => cartService.getCart())
      .take(1)
      .switchMap(cart => {

        if (cart.config.askAddressAfterPayment) {
          return Observable.of(`/${cart.contentId}/askaddress`);
        }

        return paymentService.getPaymentResult()
          .map((result) => {
            if (result.redirectTo) {
              Observable
                .never()
                .loader()
                .bindComponent(this)
                .subscribe();

              window.location.href = result.redirectTo;
              return null;
            }

            return `/thankyou/${cart.contentId}/${result.key}`;
          });
      })
      .take(1)
      .filter(url => url !== null)
      .bindComponent(this)
      .subscribe(url => {
        this.history.push(url);
      });
  }

  setHistory = (history: History): any => {
    this.history = history;
    return null;
  }

  public mainForm = () => {
    return <MainForm onPay={this.onPay} />;
  }

  public render() {

    if (!this.state) {
      return '';
    }

    const { cart } = this.state;
    const numberPayments = this.state.payment.payment.length;
    const numberInstallments = this.state.payment.payment[0].numberInstallments;

    return (
      <div className={styles.component}>
        <HistoryContext.Consumer>
          {h => this.setHistory(h)}
        </HistoryContext.Consumer>
        <section className='chk-main-container'>
          <section className='chk-container'>
            <div className='chk-form'>
              {cart.config.productType == enProductType.TICKET ?
                <PriceQuantity />
                :
                <Price
                  showConfigSelectors={true}
                  showBorder={false}
                  cart={this.state.cart}
                  hideMultipleInstallments={numberPayments > 1 || numberInstallments <= 1}
                />
              }
              <div className='chk-siderbar-form'>
                <Switch>
                  <Route exact path='/:id' render={this.mainForm} />
                  <Route exact path='/:id/askaddress' component={AskAddress} />
                </Switch>
              </div>
            </div>
            <div className='chk-sidebar'>
              <Sidebar cart={this.state.cart} />
            </div>
          </section>
        </section>

        <div className='eduzz-logo'>
          <div className='links'>
            <Footer />
          </div>
          <SvgIcon name='eduzzLogo' />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Mobile/SingleStep/index.tsx